import styled from 'styled-components'

import { media } from 'src/styles/media'
import { fontSize, fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles'

export const ContentWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;

  ${media.desktop} {
    max-width: 100rem;
    width: 100%;
    margin: auto;
  }
`

export const Title = styled.h2`
  font-size: ${fontSize.LARGE_XXXL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.GREYISH_BROWN};
  margin-left: 2rem;
`

export const OrderedList = styled.ol`
  background-color: ${color.WHITE};
  min-width: 100%;
  margin: 0;
  padding-bottom: 2.4rem;
  flex-grow: 1;

  ${media.desktop} {
    flex-grow: 0;
    padding-bottom: 3rem;
    padding-top: 4rem;
    min-width: 102rem;
  }
`

export const ListItemInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2.4rem;

  ${media.desktop} {
    margin-top: 0;
    padding: 0.5rem 0;
    margin-right: 5rem;
  }
`

export const ListItem = styled.li`
  font-size: ${fontSize.SMALL};
  color: #c2c2c2;
  font-weight: ${fontWeight.EXTRA};
  padding-left: 2rem;

  ${media.desktop} {
    padding-left: 3.4rem;

    & + & {
      ${ListItemInner} {
        border-top: 0.1rem solid ${color.VERY_LIGHT_PINK};
      }
    }
  }
`

export const OtherUserWrap = styled.div`
  display: flex;
  align-items: center;
`

export const CenterWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.7rem;

  ${media.desktop} {
    margin-left: 4.5rem;
  }
`

export const NameWrap = styled.span`
  font-size: initial;
  color: initial;
  font-weight: ${fontWeight.MEDIUM};
`

export const StatsWrap = styled.span`
  font-size: ${fontSize.SMALL};
  color: ${color.WARM_GREY};
  font-weight: ${fontWeight.REGULAR};
`

export const PercentWrap = styled.span`
  font-size: initial;
  color: initial;
  font-weight: ${fontWeight.EXTRA};
  margin-right: 4rem;

  ${media.desktop} {
    margin-right: 3rem;
  }
`

export const InviteButton = styled.button`
  position: absolute;
  display: flex;
  top: 2.2rem;
  right: 3.2rem;
  padding: 0;

  ${media.desktop} {
    display: none;
  }
`

export const Button = styled.button`
  height: 5.6rem;
  border-radius: 2.8rem;
  background-color: ${color.DULL_ORANGE};
  padding: 0 8rem;
  font-weight: ${fontWeight.BOLD};
  font-size: ${fontSize.NORMAL};
  line-height: 1.5;
  text-align: center;
  color: ${color.WHITE};
  margin-top: 2.4rem;
  align-self: center;
`

export const GetMoreWrap = styled.div`
  text-align: center;
  padding-bottom: 3rem;
`

export const SecondaryButton = styled.button`
  border-radius: 2.4rem;
  background-color: rgba(87, 61, 57, 0.15);
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.WARM_GREY};
  padding: 0.8rem 2.4rem;
`
